import { createFileRoute } from "@tanstack/react-router";
import { BlogPostPage } from "@/components/site/BlogPostPage";
import { POST_BY_SLUG } from "@/lib/blog";
import { articleSchema, faqSchema, breadcrumbSchema } from "@/components/site/SchemaJsonLd";

const SLUG = "how-long-does-a-water-heater-last-in-phoenix-phoenix-plumbing-co";
const post = POST_BY_SLUG[SLUG];
// SEO meta description (the visible subtitle keeps post.description).
const META_DESCRIPTION = "Manufacturers say 10-12 years. Phoenix hard water says less. Real lifespans for tank, tankless and hybrid water heaters, plus signs yours is near the end.";

export const Route = createFileRoute(
  "/how-long-does-a-water-heater-last-in-phoenix-phoenix-plumbing-co",
)({
  head: () => ({
    meta: [
      { title: "How Long Does a Water Heater Last in Phoenix?" },
      { name: "description", content: META_DESCRIPTION },
      { property: "og:title", content: post.title },
      { property: "og:description", content: META_DESCRIPTION },
      { property: "og:type", content: "article" },
      { property: "og:url", content: `https://www.phoenixplumbing.co/${SLUG}` },
      { name: "twitter:title", content: post.title },
      { name: "twitter:description", content: META_DESCRIPTION },
    ],
    links: [{ rel: "canonical", href: `https://www.phoenixplumbing.co/${SLUG}` }],
    scripts: [
      { type: "application/ld+json", children: JSON.stringify(articleSchema({ title: post.title, description: post.description, date: post.date, slug: SLUG })) },
      ...(post.faqs ? [{ type: "application/ld+json", children: JSON.stringify(faqSchema(post.faqs)) }] : []),
      { type: "application/ld+json", children: JSON.stringify(breadcrumbSchema([{ name: "Home", url: "/" }, { name: "Blog", url: "/blog" }, { name: post.title, url: `/${SLUG}` }])) },
    ],
  }),
  component: () => <BlogPostPage post={post} />,
});